/**
 * Wraps a number, date, amount or code interpolated into a translated sentence in an LTR isolate
 * (U+2066 … U+2069): in Arabic, « 9 800 DT » would otherwise display as « 800 9 DT ».
 */
export const ltr = (s: string | number) => `⁦${s}⁩`;
